<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">

                <div class="header-block">
                    <div class="header-title">
                        <p>Task Master</p>
                    </div>
                    
                </div>
              
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 40%;">Priority Status</th>
                            <th style="width: 40%;text-align: center;">Time In Hrs</th>
                            <th style="width: 20%;text-align: center;">Action</th>
                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading">
                    <div class="data-view" *ngFor="let list of taskPriority;let i = index">
        
                        <p style="width: 40%;">{{list.priorityStatus}}</p>
                        <p style="width: 40%;text-align: center;">{{list.timeInHrs}}</p>
                        <p style="width: 20%;text-align: center;">
                            <i class="bi bi-pencil-square" (click)="getTaskPriorityByStatus(list.priorityStatus)" data-toggle="modal" data-target="#updateModal"></i>
                        </p>
                    </div>
                </div>
        
        
                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>
        
                <div class="loader"  *ngIf="!isLoading && taskPriority.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



    



<div class="modal fade" id="updateModal" tabindex="-1" data-backdrop="static" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">Update
                    <span data-dismiss="modal">
                    <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label for="">Status</label>
                    <p>{{singleTaskPriority.priorityStatus}}</p>
                </div>
                <div class="form-group">
                    <label for="">Time</label>
                    <input type="number" name="" (keypress)="keyPressNumbers($event)" [(ngModel)]="timeInHrs" class="form-control" id="">
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="updateTaskPriorityTime()">Update</button>
                </div>
            </div>
        </div>
    </div>
</div>